import { useMemo } from 'react';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';
import useSplitter from 'src/hooks/useSplitter';
import InvoicePreviewSection from './InvoicePreviewSection';
import InvoiceScanManagerTab from './InvoiceScanManagerTab';

const InvoiceScanManagerSplitter = () => {
  const { showPrev, previewDocument, isHidePreview, selectedView } = useInvoiceScanManager();

  const PreviewSection = useMemo(
    () => (previewDocument ? <InvoicePreviewSection /> : <></>),

    [previewDocument]
  );

  const FullPage = useSplitter(
    <InvoiceScanManagerTab isAttachment={selectedView === 0} />,
    PreviewSection,
    isHidePreview ? false : showPrev
  );

  return FullPage;
};
export default InvoiceScanManagerSplitter;
